export const isStringNullishOrWhitespace = (input?: string | null): boolean => input == null || input.trim().length <= 0;

export const limitStringLength = (input: string, maxLength: number): string =>
  input?.length <= maxLength ? input : input.slice(0, maxLength);
